
import { Component, input, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Webscrape } from '@shared/index';
import { ButtonModule } from 'primeng/button';
import { IconFieldModule } from 'primeng/iconfield';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { InputIconModule } from 'primeng/inputicon';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputText } from "primeng/inputtext";
import { TableModule } from 'primeng/table';
import { FunctionNameSuggestComponent } from 'src/app/shared/components/ai-bot/utils/function-name-suggest/function-name-suggest.component';
import { HintComponent } from '@shared-angular/components/hint/hint.component';
import { DividerModule } from 'primeng/divider';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { SkillIdInputComponent } from 'src/app/shared/components/ai-bot/utils/skill-id-input/skill-id-input.component';
import { CounterService } from '@shared-angular/services/counter.service';
import { RouteShareService } from 'src/app/shared/services/route-share.service';
import { ToastrService } from '@shared-angular/services/toastr.service';
import { WebscrapeService } from 'src/app/shared/services/webscrape.service';

@Component({
  selector: 'app-offline-websites-tab-detail',
  imports: [
    FormsModule,
    SkillIdInputComponent,
    FunctionNameSuggestComponent,
    HintComponent,
    DividerModule,
    ToggleSwitchModule,
    InputText,
    InputGroupModule,
    InputGroupAddonModule,
    IconFieldModule,
    InputIconModule,
    InputNumberModule,
    TableModule,
    ButtonModule
],
  templateUrl: './offline-websites-tab-detail.component.html',
  styleUrl: './offline-websites-tab-detail.component.scss'
})
export class OfflineWebsitesTabDetailComponent {
  public readonly selectedWebscrapeId = input<string>('');
  public readonly closeDrawer = output();

  constructor(
    public service: WebscrapeService,
    private toastr: ToastrService,
    private counterService: CounterService,
    public rss: RouteShareService
  ) { }

  public async deleteWebscrapePages(offlineWeb: Webscrape, scrapepageIds: { _id: string, url: string, chunk: number }[]) {
    await this.service.deleteWebscrapePageId(offlineWeb.botId, offlineWeb._id, scrapepageIds.map(e => e._id));
    const scrape = (await this.service.getWebscrape(this.rss.botConfig._id, offlineWeb._id)).scrape;
    const index = this.rss.webscrapes.findIndex(s => s._id == scrape._id);
    this.rss.webscrapes[index] = scrape;
    if (this.rss.webscrape?._id == scrape._id) {
      this.rss.webscrape = scrape;
    }
    this.toastr.success("SAVED", "Offline Unterseiten wurden gelöscht");
  }
}
